// src/components/LanguageSwitcher/LanguageSwitcher.tsx

import React from "react";
import styles from "./LanguageSwitcher.module.scss";
import { useTranslation } from "react-i18next";

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className={styles.languageSwitcher}>
      <button onClick={() => changeLanguage("en")}>English</button>
      <span>|</span>
      <button onClick={() => changeLanguage("zh")}>简体中文</button>
    </div>
  );
};

export default LanguageSwitcher;
